import React from 'react';

import IntegrationImage, { integrationImageById } from 'assets/img/integrations';

import styles from './SettingsIntegrationIcon.module.scss';

interface SettingsIntegrationIconProps extends StyleProps {
  /** @string - Integration name */
  itemIntegrationName: string;
}

export const SettingsIntegrationIcon: React.FC<SettingsIntegrationIconProps> = ({
  itemIntegrationName,
}) => {
  const integrationIcon = integrationImageById(
    itemIntegrationName,
    IntegrationImage,
    true,
    styles.appIcon
  );

  return <>{itemIntegrationName && integrationIcon}</>;
};
